import { styled } from '@mui/system';
import Popover from '@mui/material/Popover';

export const SidebarGroupPopover = styled(Popover)({
  '& .MuiPaper-root': {
    width: '228px',
    background: '#ffffff',
    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 2px 8px',
    border: 'none',
    borderRadius: '4px',
    paddingBottom: '5px',
    marginLeft: '14px',
    padding: 0,
  },
});
